import { Buffer } from 'buffer';

(globalThis as any).Buffer = Buffer; // @react-pdf/renderer v4 uses Buffer for PDF generation

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import Root from './root';

import 'antd/dist/reset.css';

import './common/services/i18n';
import './root/styles/main.less';

createRoot(document.querySelector('#root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
